export enum TerminationTypes {
	Employment = 'employment',
	Death = 'death',
	NeverWorkedHere = 'NeverWorkedHere',
	LeaveOfAbsence = 'LOA',
}

export interface TerminationConfirmationPageContentModel {
	pageTitle: string;
	terminatedEmployeeHeader: string;
	terminatedEmployeeDescription: string;
	nextStepsHeader: string;
	groupHealthLifeMessage: string;
	terminateBenefitsLinksText: string;
	nonGroupAdminNextStepsMessage: string;
	benefitTerminatedTitle?: string;
	benefitTerminatedDescription?: string;
	loaText?: string;
}
export interface BenefitEndDate {
	termination_date: string;
	plan_type: string;
	end_date?: string;
	plan_name?: string;
	reason?: string;
}